import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Sondage, OptionSondage } from '../models/sondage.model';

@Injectable({
  providedIn: 'root'
})
export class SondageService {

  private apiUrl = 'https://be.festivalsousse.com/api/sondages';

  constructor(private http: HttpClient) { }

  getSondageActif(): Observable<Sondage> {
    return this.http.get<Sondage>(`${this.apiUrl}/actif`);
  }

  getTous(): Observable<Sondage[]> {
    return this.http.get<Sondage[]>(this.apiUrl);
  }

  creer(question: string, options: string[]): Observable<Sondage> {
    return this.http.post<Sondage>(this.apiUrl, { question, options });
  }

  activer(id: number): Observable<Sondage> {
    return this.http.put<Sondage>(`${this.apiUrl}/${id}/activer`, {});
  }

  voter(optionId: number): Observable<OptionSondage> {
    return this.http.post<OptionSondage>(`${this.apiUrl}/voter/${optionId}`, {});
  }

  supprimer(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
